document.ready(() => {
    const toast = document.getElementById("sazka-notification");
    const toastText = document.getElementById("sazka-notification-text");
    const elementHeight = toastText?.getBoundingClientRect().height;
    const mq = window.matchMedia("(max-width: 480px)");

    if (!toast || !toastText) {
        return;
    }

    function calculateDynamicHeight() {
        if (elementHeight > 64 && mq.matches) {
            toast.style.setProperty("--notification-height", `${elementHeight}px`);
        } else {
            toast.removeAttribute("style");
        }
    }

    mq.addEventListener("change", calculateDynamicHeight);

    calculateDynamicHeight();
});
